import { useNavigate } from 'react-router-dom';
import { AcademicCapIcon } from '@heroicons/react/24/outline';
import HomeKnowledgeSection from './HomeKnowledgeSection';
import Testimony from '../SignUp/Testimony';
import SharedButton from '@/global/Button/Button';
import useText from '@/hooks/useText';
import { userAppContext } from '@/context/Context';

function Container2() {
  const navigate = useNavigate();
  const testimonialsLabel = useText('home.testimonials.label');
  const testimonialsTitle = useText('home.testimonials.title');
  const ctaTitle = useText('home.cta.title');
  const ctaSubtitle = useText('home.cta.subtitle');
  const ctaBtnStartTrial = useText('home.cta.btn_start_trial');
  const ctaBtnViewPlans = useText('home.cta.btn_view_plans');
  const ctaAcademicTitle = useText('home.cta.academic_title');
  const ctaAcademicDescription = useText('home.cta.academic_description');
  const ctaAcademicBtn = useText('home.cta.academic_btn');

  const { isAuthenticated } = userAppContext();

  return (
    <>
      <HomeKnowledgeSection />
      <section id="testimonials" className="home-section home-section-dark home-testimonials scroll-reveal">
        <div className="text-center">
          <span className="home-section-label text-pink mb-4">{testimonialsLabel}</span>
          <h2 className="home-section-title home-section-title-center home-section-title-light text-white">
            {testimonialsTitle}
          </h2>
        </div>
        <Testimony variant="cards" />
      </section>
      {!isAuthenticated && (
        <section className="home-section home-section-light home-cta-section scroll-reveal">
          <div className="home-cta-grid">
            <div className="home-cta-left">
              <h2 className="home-section-title">{ctaTitle}</h2>
              <p className="home-cta-subtitle">{ctaSubtitle}</p>
              <div className="home-cta-buttons">
                <SharedButton
                  type="button"
                  className="btn-gradient-pink"
                  onClick={() => navigate('/free-trial-apply')}
                >
                  {ctaBtnStartTrial}
                </SharedButton>
                <button type="button" className="home-cta-btn-outline" onClick={() => navigate('/plans')}>
                  {ctaBtnViewPlans}
                </button>
              </div>
            </div>
            <div className="home-cta-card home-cta-card-academic home-card-elevated">
              <div className="home-cta-card-header">
                <div className="home-cta-card-icon-wrap">
                  <AcademicCapIcon className="home-cta-card-heroicon" aria-hidden />
                </div>
                <h3 className="home-card-title">{ctaAcademicTitle}</h3>
              </div>
              <p className="home-card-description">{ctaAcademicDescription}</p>
              <SharedButton
                type="button"
                className="home-cta-card-btn home-cta-card-btn-outline ml-0"
                onClick={() => navigate('/academic-apply')}
              >
                {ctaAcademicBtn}
              </SharedButton>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default Container2;
